import React from "react";
import { TimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { Settings } from "luxon";
import { Controller, useFormContext } from "react-hook-form";
import type { UseControllerProps } from "react-hook-form/dist/types/controller";

interface FormNonLocalizedTimePickerProps extends UseControllerProps {
  label: string;
}

export function FormNonLocalizedTimePicker(props: FormNonLocalizedTimePickerProps) {
  const { control } = useFormContext();

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={Settings.defaultLocale}>
      <Controller
        name={props.name}
        rules={props.rules}
        shouldUnregister={props.shouldUnregister}
        control={control}
        render={({ field: { ref, ...rest }, fieldState }) => {
          let helperText = null;

          if (fieldState.invalid) {
            helperText = fieldState.error?.message;
          }

          return (
            <TimePicker
              {...rest}
              label={props.label}
              slotProps={{
                textField: {
                  variant: "outlined",
                  required: !!props.rules?.required,
                  error: fieldState.invalid,
                  helperText,
                  fullWidth: true,
                },
              }}
            />
          );
        }}
      />
    </LocalizationProvider>
  );
}
